import * as Types from '../../../../../graphql.generated';

export type SocialSignInGoogleMutationVariables = Types.Exact<{
    accessToken: Types.Scalars['String'];
}>;

export type SocialSignInGoogleMutation = { __typename?: 'Mutation' } & {
    socialSignInGoogle?: Types.Maybe<
        { __typename?: 'SocialSignInGoogleResponse' } & Pick<
            Types.SocialSignInGoogleResponse,
            'success'
        >
    >;
};

export const SocialSignInGoogleDocument = `
    mutation socialSignInGoogle($accessToken: String!) {
  socialSignInGoogle(accessToken: $accessToken) {
    success
  }
}
    `;
export type Requester<C = {}> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C>(requester: Requester<C>) {
    return {
        socialSignInGoogle(
            variables: SocialSignInGoogleMutationVariables,
            options?: C
        ): Promise<SocialSignInGoogleMutation> {
            return requester<
                SocialSignInGoogleMutation,
                SocialSignInGoogleMutationVariables
            >(SocialSignInGoogleDocument, variables, options);
        }
    };
}
export type Sdk = ReturnType<typeof getSdk>;
